require('../widgets/jCombobox');

export default class Combobox {
  initializeListeners() {
    $('[data-combobox]').toArray().forEach(input => $(input).combobox());
  }
}
